import api from '@/apis/di/inventoryCategoryAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Loại VT, HH
export const useInventoryCategoryComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onInventoryCategoryComboboxLoadData = (payload, row, column, customData) => {
    payload.sort = 'inventory_category_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };

  // config columns combo
  const inventoryCategoryComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã loại VTHH',
        dataField: 'inventory_category_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên loại VTHH',
        dataField: 'inventory_category_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'inventory_category_code',
    valueField: 'inventory_category_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onInventoryCategoryComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    inventoryCategoryComboConfig,
    onInventoryCategoryComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
